/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { Component, Input, OnChanges, SkipSelf } from "@angular/core";
import { AbstractControl, ControlContainer } from "@angular/forms";
import { Observable } from "rxjs";
import { endOfMonth, endOfQuarter, endOfWeek, endOfYear ,differenceInCalendarDays} from "date-fns";
import * as _ from "lodash";
import { SchemaBuilderBuilderData } from "../../interfaces/schema-builder.interface";
import { FormErrorValidationService } from "../../services/form-error-validation.service";
import { SchemaComponentTypes } from "../../enums/schema-builder-types.enum";
import { NzSelectModeType } from "ng-zorro-antd/select";
import { Time } from '@angular/common';

@Component({
  selector: "app-schema-builder",
  templateUrl: "./schema-builder.component.html",
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
})

export class SchemaBuilderComponent implements OnChanges {
  @Input() schemaData!: any;
  @Input() f!: any; // Instance of form control from parent component
  @Input() formGroupData!: string[]; // List of formgroup required to create the form
  @Input() formData!: {[key: string]:  Observable<any>}// Observables from parent component for Select Option List
  @Input() tabname!:string;
  @Input() functionList!:  { [key: string]: { (...prams: any): any }}; // Callback Function from parent component
  @Input() params:any={};
  @Input() fileList:any[] = [];
  dateRange : any; // Default dates for Date Range Picker
  componentTypes=SchemaComponentTypes;
  // Extra params for Date Range Picker
  dateRangeExtra = {
    "Today": [new Date(), new Date()],
    "This Week": [new Date(), endOfWeek(new Date())],
    "This Month": [new Date(), endOfMonth(new Date())],
    "This Quarter": [new Date(), endOfQuarter(new Date())],
    "This Year": [new Date(), endOfYear(new Date())],
  };

  disabledDate = (current: Date): boolean => {
    return false;
  }
  disableTime = (current: Time): boolean => {
    return false;
  }

  data: any = {};
  dataKeys: string[] = [];
  constructor(public formValidationService : FormErrorValidationService) {}

  ngOnChanges() {
    const data = {};
    const form = {};
    if (Array.isArray(this.schemaData)) {
      for (let i = 0; i < this.schemaData.length; i++) {
        _.merge(
          data,
          _.pickBy(this.schemaData[i], (n) => {
            n.formGroupData = this.formGroupData[i];
            return n.tabs == this.tabname;
          })
        );
        _.merge(form, this.f[i]);
      }
      this.schemaData = this.sortBySequence(data);
      this.f = form;
    }
    this.dataKeys = Object.keys(this.schemaData);
  }

  //
  /**
   * @param  {{[x:string]:any}} obj
   */
  sortBySequence = (obj: { [x: string]: any }) => {
    const order: any = [];
    const res: any = {};
    Object.keys(obj).forEach((key) => {
      return (order[obj[key]["sequence"] - 1] = key);
    });
    order.forEach((key: string) => {
      res[key] = obj[key];
    });
    return res;
  };

  get commonConstants() {
    return '12';
  }

  getNzMode(val:string):NzSelectModeType{
    if(val == undefined)
      return 'default';
    else
      return val as NzSelectModeType;
  }
}
